var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    : _c("div", { attrs: { id: "shelvery-status" } }, [
        _c(
          "nav",
          { staticClass: "navbar fixed-top-sub navbar-light bg-light" },
          [
            _c("div", { staticClass: "navbar-brand" }, [
              _vm._v("Shelvery Run Status")
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "nav nav-pages mr-auto" },
              _vm._l(_vm.visibleTabs, function(tab) {
                return _c("li", { key: tab.id, staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.activeTab.id === tab.id },
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.setTab(tab)
                        }
                      }
                    },
                    [_vm._v("\n          " + _vm._s(tab.name) + "\n        ")]
                  )
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "nav-item btn-group dropdown" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn-block btn dropdown-toggle btn-secondary text-right",
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.periodShort) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-menu dropdown-menu-right scrollable-menu"
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      class: { "active-period": _vm.period === null },
                      on: {
                        click: function($event) {
                          return _vm.setPeriod(null, null)
                        }
                      }
                    },
                    [_vm._v("Latest")]
                  ),
                  _vm._v(" "),
                  _c("h6", { staticClass: "dropdown-header" }, [
                    _vm._v("Days")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.dayOptions, function(day) {
                    return _c(
                      "a",
                      {
                        key: day,
                        staticClass: "dropdown-item",
                        class: {
                          "active-period":
                            _vm.period === "day" && _vm.date === day
                        },
                        on: {
                          click: function($event) {
                            return _vm.setPeriod("day", day)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.formatDay(day)))]
                    )
                  }),
                  _vm._v(" "),
                  _c("h6", { staticClass: "dropdown-header" }, [
                    _vm._v("Months")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.monthOptions, function(month) {
                    return _c(
                      "a",
                      {
                        key: month,
                        staticClass: "dropdown-item",
                        class: {
                          "active-period":
                            _vm.period === "month" && _vm.date === month
                        },
                        on: {
                          click: function($event) {
                            return _vm.setPeriod("month", month)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.formatMonth(month)))]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _vm.accounts.length > 1
              ? _c("div", { staticClass: "nav-item btn-group dropdown" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn-block btn dropdown-toggle btn-secondary text-right",
                      staticStyle: { "margin-right": "10px" },
                      attrs: {
                        type: "button",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.activeAccount) + "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "dropdown-menu dropdown-menu-right scrollable-menu"
                    },
                    [
                      _c("h6", { staticClass: "dropdown-header" }, [
                        _vm._v("Accounts")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.accounts, function(account) {
                        return _c("div", { key: account }, [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function($event) {
                                  return _vm.setAccount(account)
                                }
                              }
                            },
                            [_vm._v(_vm._s(account))]
                          )
                        ])
                      })
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.allReports.length > 0
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary text-right",
                    attrs: { type: "button" },
                    on: { click: _vm.downloadCSV }
                  },
                  [_vm._v("Download CSV")]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _vm.allReports.length > 0
                ? [
                    _c("transition", { attrs: { name: "fade", appear: "" } }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-heading" }, [
                          _c("h4", [_vm._v(_vm._s(_vm.healthHeading))])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c(
                            "div",
                            { staticClass: "kpi-row" },
                            _vm._l(_vm.kpis, function(tile) {
                              return _c(
                                "div",
                                { key: tile.label, staticClass: "kpi" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "kpi-value",
                                      class: tile.tone
                                    },
                                    [_vm._v(_vm._s(tile.value))]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "kpi-label" }, [
                                    _vm._v(_vm._s(tile.label))
                                  ])
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "kpi-note" }, [
                            _vm._v(_vm._s(_vm.kpiNote))
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "fade", appear: "" } }, [
                      _vm.failingRuns.length > 0
                        ? _c("div", { staticClass: "card issue-card" }, [
                            _c("div", { staticClass: "card-heading" }, [
                              _c("h4", [_vm._v("Needs attention")])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-body" }, [
                              _c(
                                "ul",
                                { staticClass: "attention-list" },
                                _vm._l(_vm.failingRuns, function(run) {
                                  return _c(
                                    "li",
                                    {
                                      key: _vm.runKey(run),
                                      staticClass: "attention-row",
                                      on: {
                                        click: function($event) {
                                          return _vm.jumpTo(run)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _c(
                                          "span",
                                          { staticClass: "attention-account" },
                                          [_vm._v(_vm._s(run.account_name))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "attention-detail" },
                                          [
                                            _vm._v(
                                              _vm._s(run.backup_type) +
                                                " · " +
                                                _vm._s(run.action)
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "status-chip",
                                          class: _vm.statusClass(run.status)
                                        },
                                        [_vm._v(_vm._s(run.status))]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "fade", appear: "" } }, [
                      _c("div", { staticClass: "card" }, [
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          [
                            _c(
                              "vue-good-table",
                              {
                                attrs: {
                                  columns: _vm.tableColumns,
                                  rows: _vm.rows,
                                  "search-options": {
                                    enabled: true,
                                    skipDiacritics: true,
                                    placeholder: "filter runs"
                                  },
                                  "pagination-options": {
                                    enabled: true,
                                    perPage: 25
                                  },
                                  "sort-options": {
                                    enabled: true,
                                    initialSortBy: {
                                      field: "status",
                                      type: "desc"
                                    }
                                  },
                                  "row-style-class": _vm.rowStyleFn,
                                  styleClass: "vgt-table condensed"
                                },
                                on: { "on-row-click": _vm.onRowClick },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "table-row",
                                      fn: function(props) {
                                        return [
                                          props.column.field === "status"
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "status-chip",
                                                  class: _vm.statusClass(
                                                    props.row.status
                                                  )
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.row.status)
                                                  )
                                                ]
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    props.formattedRow[
                                                      props.column.field
                                                    ]
                                                  )
                                                )
                                              ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  496263415
                                )
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "table-actions" },
                                    slot: "table-actions"
                                  },
                                  [
                                    _vm.hiddenInactive > 0 || _vm.showInactive
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-secondary btn-margin btn-sm",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                _vm.showInactive = !_vm.showInactive
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.showInactive
                                                    ? "Hide inactive"
                                                    : _vm.hiddenInactive +
                                                        " inactive hidden"
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-danger btn-margin btn-sm",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            _vm.showOnlyFailures = !_vm.showOnlyFailures
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.showOnlyFailures
                                                ? "Show all runs"
                                                : "Show failures only"
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-center",
                                    attrs: { slot: "emptystate" },
                                    slot: "emptystate"
                                  },
                                  [
                                    _vm._v(
                                      "\n                nothing to show for " +
                                        _vm._s(
                                          _vm.activeTab.name.toLowerCase()
                                        ) +
                                        " in " +
                                        _vm._s(_vm.activeAccount) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "fade", appear: "" } }, [
                      _vm.selected != null
                        ? _c("div", { staticClass: "card issue-card" }, [
                            _c("div", { staticClass: "card-heading" }, [
                              _c("h4", [
                                _vm._v(
                                  _vm._s(_vm.selected.backup_type) +
                                    " " +
                                    _vm._s(_vm.selected.action)
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-body run-detail" }, [
                              _vm.isMonthView
                                ? _c("dl", [
                                    _c("dt", [_vm._v("Month")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatMonth(_vm.selected.month)
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Account")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        _vm._s(_vm.selected.account_name) + " "
                                      ),
                                      _c("span", { staticClass: "muted" }, [
                                        _vm._v(
                                          "(" +
                                            _vm._s(_vm.selected.account_id) +
                                            ")"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Scope")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        _vm._s(_vm.selected.backup_type) +
                                          " · " +
                                          _vm._s(_vm.selected.action) +
                                          " · " +
                                          _vm._s(_vm.selected.region)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Days run")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        _vm._s(_vm.selected.days_run) + " "
                                      ),
                                      _c("span", { staticClass: "muted" }, [
                                        _vm._v(
                                          "(" +
                                            _vm._s(_vm.selected.runs) +
                                            " runs)"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Ran between")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDay(_vm.selected.first_run)
                                        ) +
                                          " – " +
                                          _vm._s(
                                            _vm.formatDay(_vm.selected.last_run)
                                          )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Status")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "status-chip",
                                          class: _vm.statusClass(
                                            _vm.selected.status
                                          )
                                        },
                                        [_vm._v(_vm._s(_vm.selected.status))]
                                      )
                                    ])
                                  ])
                                : _c("dl", [
                                    _c("dt", [_vm._v("Run")]),
                                    _vm._v(" "),
                                    _c("dd", { staticClass: "run-id" }, [
                                      _vm._v(_vm._s(_vm.selected.run_id))
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Account")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        _vm._s(_vm.selected.account_name) + " "
                                      ),
                                      _c("span", { staticClass: "muted" }, [
                                        _vm._v(
                                          "(" +
                                            _vm._s(_vm.selected.account_id) +
                                            ")"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Scope")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        _vm._s(_vm.selected.backup_type) +
                                          " · " +
                                          _vm._s(_vm.selected.action) +
                                          " · " +
                                          _vm._s(_vm.selected.region)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Finished")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatTimestamp(
                                            _vm.selected.ended_at
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Status")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "status-chip",
                                          class: _vm.statusClass(
                                            _vm.selected.status
                                          )
                                        },
                                        [_vm._v(_vm._s(_vm.selected.status))]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Shelvery")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        _vm._s(_vm.selected.shelvery_version)
                                      )
                                    ])
                                  ]),
                              _vm._v(" "),
                              _vm.isMonthView
                                ? _c("div", { staticClass: "detail-section" }, [
                                    _c("h5", [_vm._v("Day by day")]),
                                    _vm._v(" "),
                                    _c("table", { staticClass: "entries" }, [
                                      _c("thead", [
                                        _c("tr", [
                                          _c("th", [_vm._v("Day")]),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("Status")]),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("Runs")]),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("Runs failed")]),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("Resources failed")])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        _vm._l(_vm.selectedDays, function(day) {
                                          return _c("tr", { key: day.day }, [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(_vm.formatDay(day.day))
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "status-chip",
                                                  class: _vm.statusClass(
                                                    day.status
                                                  )
                                                },
                                                [_vm._v(_vm._s(day.status))]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(day.runs))
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(day.failed))
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(day.resources_failed)
                                              )
                                            ])
                                          ])
                                        }),
                                        0
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "detail-section" }, [
                                _c("h5", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isMonthView
                                        ? "Resources, last run of the month"
                                        : "Resources"
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.detailEntries.length === 0
                                  ? _c("p", { staticClass: "kpi-note mb-0" }, [
                                      _vm._v(
                                        "\n                  No per resource detail was recorded for this run.\n                "
                                      )
                                    ])
                                  : _c("table", { staticClass: "entries" }, [
                                      _c("thead", [
                                        _c("tr", [
                                          _c("th", [_vm._v("Operation")]),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("Resource")]),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("Retention")]),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("Backup")]),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("Status")])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        [
                                          _vm._l(_vm.detailEntries, function(
                                            entry,
                                            index
                                          ) {
                                            return [
                                              _c(
                                                "tr",
                                                {
                                                  key: "entry-" + index,
                                                  class: {
                                                    "has-error": entry.error
                                                  }
                                                },
                                                [
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(entry.operation)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "entry-name"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            entry.entity_name ||
                                                              entry.entity_id ||
                                                              "—"
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    entry.entity_name &&
                                                    entry.entity_id
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "entry-id"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                entry.entity_id
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        entry.retention_type ||
                                                          "—"
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "entry-backup"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.backup_name ||
                                                            "—"
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "status-chip",
                                                        class: _vm.statusClass(
                                                          entry.status
                                                        )
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(entry.status)
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              entry.error
                                                ? _c(
                                                    "tr",
                                                    {
                                                      key: "err-" + index,
                                                      staticClass:
                                                        "entry-error-row"
                                                    },
                                                    [
                                                      _c(
                                                        "td",
                                                        {
                                                          attrs: {
                                                            colspan: "5"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(entry.error)
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          })
                                        ],
                                        2
                                      )
                                    ]),
                                _vm._v(" "),
                                _vm.detailOmitted > 0
                                  ? _c("p", { staticClass: "kpi-note" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.detailOmitted) +
                                          " further successful entries were omitted from this report.\n                "
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ])
                        : _vm._e()
                    ])
                  ]
                : _vm._e()
            ],
            2
          )
        ]),
        _vm._v(" "),
        _vm.allReports.length === 0
          ? _c("div", { staticClass: "row empty-state" }, [
              _c("div", { staticClass: "col text-center" }, [
                _vm.period
                  ? _c("h4", [
                      _vm._v(
                        "No shelvery runs reported for " +
                          _vm._s(_vm.periodLabel)
                      )
                    ])
                  : _c("h4", [_vm._v("No Shelvery run status available")]),
                _vm._v(" "),
                _vm.period
                  ? _c("p", [
                      _vm._v(
                        "History starts from the day shelvery began publishing status reports. Pick another period, or go back to Latest."
                      )
                    ])
                  : _c("p", [
                      _vm._v(
                        "Run status will appear here once shelvery is publishing status reports for this contract."
                      )
                    ])
              ])
            ])
          : _vm._e()
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f63f63e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f63f63e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ShelveryStatus.vue
// module id = null
// module chunks = 